.unsetRequired {
    border-style: solid;
    border-width: 1px;
}

.label {
    max-width: 800px;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}
